<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="模板名称">
					<c-input name="template_name" maxlength="20"></c-input>
				</m-search-item>
        <m-search-item label="状态">
          <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
        </m-search-item>
        <m-search-item label="分类">
          <c-select name="category_id" async @search="searchCategory"></c-select>
        </m-search-item>
				<m-search-item label="标签">
					<c-input name="label" maxlength="20"></c-input>
				</m-search-item>
				<m-search-item label="备注">
					<c-input name="remark" maxlength="20"></c-input>
				</m-search-item>
				<m-search-item label="添加时间" colspan="2">
          <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button color="main" v-if="auth('b_release_template_edit')" prepend-icon="tf-add" @click="$refs.templateEdit.open()">添加模板</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true">
        <!--<c-table-column type="selector" width="32"></c-table-column>-->
        <c-table-column
            label="模板名称"
            name="template_name"
            width="150"
            fixed="left"
        >
        </c-table-column>

        <!-- 是否启用 -->
        <c-table-column
            label="状态"
            name="status"
            width="80"
            fixed="left"
        >
          <template #default="{data}">
            <c-switch v-if="auth('b_release_template_edit')" v-model="data.status" :state-value="[1, 0]" :state-text="['启用','禁用']"
                      @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
            <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
          </template>
        </c-table-column>


        <c-table-column
            label="分类"
            name="category_name"
            width="100"
        >
        </c-table-column>

        <c-table-column
            label="标签"
            name="label"
            width="100"
        >
        </c-table-column>

        <c-table-column
            label="是否通用"
            name="general_purpose_flag"
            width="100"
        >
          <template #default="{data}">
            <c-state dict="enableDic" tag :value="data.general_purpose_flag"></c-state>
          </template>
        </c-table-column>

        <c-table-column
            label="备注"
            name="remark"
            width="150"
        >
          <template #default="{data}">
            <span v-if="data.remark">{{data.remark}}</span>
            <span v-else>-</span>
          </template>
        </c-table-column>

				<c-table-column
					label="添加人"
					name="create_user_name"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="添加时间"
					name="create_date"
					width="130"
				>
				</c-table-column>

        <c-table-column
            label="排序"
            type="sort"
            fixed="right"
            @handle="sortHandle">
        </c-table-column>

				<c-table-column
					type="button"
					label="操作"
          width="165"
					button-limit="6"
				>
					<template #default="{data}">
            <c-table-button v-if="auth('b_release_template_config')" icon="tf-setting" @click="$refs.templateReleaseConfig.open(data)">配置质检项</c-table-button>
            <c-table-button v-if="auth('b_release_template_edit')" icon="tf-edit" @click="$refs.templateEdit.open(data)">编辑</c-table-button>
            <c-table-button v-if="auth('b_release_template_edit')" icon="tf-copy" @click="$refs.templateCopy.open(data)">复制</c-table-button>
						<c-table-button v-if="auth('b_release_template_edit')" icon="tf-trash" color="red" @click="removeTemplate(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--添加/编辑模板信息弹窗-->
			<template-edit ref="templateEdit" @resolve="$refs.list.update()"></template-edit>
			<!--复制模板信息弹窗-->
			<template-copy ref="templateCopy" @resolve="$refs.list.update()"></template-copy>
			<!--配置质检项信息弹窗-->
			<template-release-config ref="templateReleaseConfig" @resolve="$refs.list.update()"></template-release-config>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import templateEdit from "@/pages/spv/template_edit.vue";
	import templateCopy from "@/pages/spv/template_copy.vue";
	import templateReleaseConfig from "@/pages/spv/template_release_config.vue";

	export default {
		components: {
      templateEdit,
      templateCopy,
      templateReleaseConfig
		},
		computed: {
      // 获取dictName选项数据
      ...mapState(['disableEnableDic','enableDic'])
		},

		props: {
			type: String
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
      /*******搜索分类*****************/
      searchCategory(keyword, resolve){
        this.request({
          url:'/spu/category/options',
          data: {
            keyword: keyword
          },
          success:data => {
            resolve(data);
          }
        })
      },

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/spu/template/list',
					data
				});
			},
			
			/******启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/spu/template/edit/status',
					data: {
            id:data.id,
            status: state ? 2 : 1   //1：启用； 2：禁用
					},
					success: () => {
						this.$message({
							message:'操作成功',  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},

			/******删除模板***********/
			removeTemplate(data){
				this.$confirm({
					message:'确认删除模板【'+data.template_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/spu/template/remove',
							data: {
                id:data.id
              },
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

      /********************排序**************************/
      sortHandle(row, type, next) {
          this.request({
            url: '/spu/template/sort',
            data: {
              id: row.data.id,
              type: ['top', 'bottom'].includes(type) ? type : '',
              id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
              id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
            },
            loading: true,
            success: data => {
                // next();
                this.$refs.list.update();
            }
          });
      },
		}
	}
</script>

<style lang="stylus" scoped>
</style>